import script from "./ContentTypeBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentTypeBadge.vue?vue&type=script&setup=true&lang=js"

import "./ContentTypeBadge.vue?vue&type=style&index=0&id=4b0c35df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b0c35df"]])

export default __exports__